import React from "react";

import Layout from "../components/layout";

const PrivacyPolicyPage = () => (
  <Layout>
    <div className="container mt-5">
      <div className="row">
        <div className="col">
          <h1 className="font-weight-bold">Privacy Policy</h1>
          <p>Effective date: June 03, 2019</p>
          <p className="pt-3">
            Tramo ("us", "we", or "our") operates the Tramo macOS application
            (hereinafter referred to as the "Service").
          </p>
          <p>
            This page informs you of our policies regarding the collection, use,
            and disclosure of personal data when you use our Service and the
            choices you have associated with that data.
          </p>
          <p>
            We use your data to provide and improve the Service. By using the
            Service, you agree to the collection and use of information in
            accordance with this policy. Unless otherwise defined in this
            Privacy Policy, the terms used in this Privacy Policy have the same
            meanings as in our Terms and Conditions.
          </p>

          <h2 className="font-weight-bold pt-3">
            Information Collection And Use
          </h2>
          <p className="pt-3">
            We collect several different types of information for various
            purposes to provide and improve our Service to you.
          </p>

          <h3 className="font-weight-bold pt-3">Types of Data Collected</h3>

          <h4 className="pt-3">Personal Data</h4>
          <p className="pt-3">
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you ("Personal Data"). Personally identifiable information
            may include, but is not limited to:
          </p>

          <ul>
            <li>Usage Data</li>
          </ul>

          <h4 className="pt-3">Usage Data</h4>

          <p className="pt-3">
            When you access the Service, we may collect certain information
            automatically, including, but not limited to, the type of device you
            use, your device unique ID, the IP address of your device, your
            device operating system, unique device identifiers and other
            diagnostic data ("Usage Data").
          </p>

          <h2 className="font-weight-bold pt-3">Use of Data</h2>

          <p className="pt-3">
            Tramo uses the collected data for various purposes:
          </p>
          <ul>
            <li>To provide and maintain the Service</li>
            <li>To notify you about changes to our Service</li>
            <li>
              To allow you to participate in interactive features of our Service
              when you choose to do so
            </li>
            <li>To provide customer care and support</li>
            <li>
              To provide analysis or valuable information so that we can improve
              the Service
            </li>
            <li>To monitor the usage of the Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>

          <h2 className="font-weight-bold pt-3">Disclosure Of Data</h2>

          <h3 className="font-weight-bold pt-3">Legal Requirements</h3>
          <p className="pt-3">
            Tramo may disclose your Personal Data in the good faith belief that
            such action is necessary to:
          </p>
          <ul>
            <li>To comply with a legal obligation</li>
            <li>To protect and defend the rights or property of Tramo</li>
            <li>
              To prevent or investigate possible wrongdoing in connection with
              the Service
            </li>
            <li>
              To protect the personal safety of users of the Service or the
              public
            </li>
            <li>To protect against legal liability</li>
          </ul>

          <h2 className="font-weight-bold pt-3">Security Of Data</h2>
          <p className="pt-3">
            The security of your data is important to us, but remember that no
            method of transmission over the Internet, or method of electronic
            storage is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee
            its absolute security.
          </p>

          <h2 className="font-weight-bold pt-3">Service Providers</h2>
          <p className="pt-3">
            We may employ third party companies and individuals to facilitate
            our Service ("Service Providers"), to provide the Service on our
            behalf, to perform Service-related services or to assist us in
            analyzing how our Service is used.
          </p>
          <p>
            These third parties have access to your Personal Data only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose.
          </p>

          <h3 className="font-weight-bold pt-3">Analytics</h3>
          <p className="pt-3">
            We may use third-party Service Providers to monitor and analyze the
            use of our Service.
          </p>
          <ul>
            <li>
              <p>
                <strong>Mixpanel</strong>
              </p>
              <p>
                Mixpanel is a analytics service. Read the Privacy Policy for
                Mixpanel here:{" "}
                <a href="https://mixpanel.com/legal/privacy-policy/">
                  https://mixpanel.com/legal/privacy-policy/
                </a>
              </p>
            </li>
          </ul>

          <h2 className="font-weight-bold pt-3">Links To Other Sites</h2>
          <p className="pt-3">
            Our Service may contain links to other sites that are not operated
            by us. If you click on a third party link, you will be directed to
            that third party's site. We strongly advise you to review the
            Privacy Policy of every site you visit.
          </p>
          <p>
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </p>

          <h2 className="font-weight-bold pt-3">Children's Privacy</h2>
          <p className="pt-3">
            Our Service does not address anyone under the age of 18
            ("Children").
          </p>
          <p>
            We do not knowingly collect personally identifiable information from
            anyone under the age of 18. If you are a parent or guardian and you
            are aware that your Children has provided us with Personal Data,
            please contact us. If we become aware that we have collected
            Personal Data from children without verification of parental
            consent, we take steps to remove that information from our servers.
          </p>

          <h2 className="font-weight-bold pt-3">
            Changes To This Privacy Policy
          </h2>
          <p className="pt-3">
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </p>
          <p>
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update the
            "effective date" at the top of this Privacy Policy.
          </p>
          <p>
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>

          <h2 className="font-weight-bold pt-3">Contact Us</h2>
          <p className="pt-3">
            If you have any questions about this Privacy Policy, please contact
            us:
          </p>
          <ul>
            <li>
              By email: <a href="mailto:nickvor@gmail.com">nickvor@gmail.com</a>
            </li>
            <li>
              By visiting this page on our website:{" "}
              <a href="https://angry-bell-5a02af.netlify.com">
                https://angry-bell-5a02af.netlify.com
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
);

export default PrivacyPolicyPage;
